var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.645 0H4.35499C1.94979 0 0 1.88889 0 4.21895V26.781C0 29.1111 1.94979 31 4.35499 31H27.645C30.0502 31 32 29.1111 32 26.781V4.21895C32 1.88889 30.0502 0 27.645 0Z",
    fill: "#121E35"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20,
    transform: "translate(11 6)",
    fill: "#121E35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4907 26V16.8776H20.4391L20.8806 13.322H17.4907V11.0521C17.4907 10.0223 17.7657 9.32121 19.1872 9.32121L21 9.32029V6.14004C20.6863 6.09702 19.6106 6 18.3583 6C15.7453 6 13.9558 7.65671 13.9558 10.6997V13.3216H11V16.8771H13.9558V25.9995H17.4911L17.4907 26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f2c734ba39c8e1748c7697b811b3480d.svg";
export { ForwardRef as ReactComponent };